import useLocalStore from '../../../../hooks/useLocalStore.js';
import { useSelector, useDispatch } from 'react-redux';
import FJRequirementsUtil from '../../../../util/FJRequirementsUtil.js';
import FJActionModal from '../../../../redux/action/FJActionModal.js';
import FJAIVideoGeneratorBtnGroup from '../view/FJAIVideoGeneratorBtnGroup.jsx';
import { useState } from 'react';
import PropTypes from 'prop-types';

const FJAIVideoGeneratorBtnGroupContainer = props => {
    useLocalStore();
    const dispatch = useDispatch();
    const creationList = useSelector(state => state.common.creationList);
    const addAsEditPageModalBtuStatus = useSelector(state => state.modals.addAsEditPageModalBtuStatus);
    const { width } = props;
    const [isDownload, setIsDownload] = useState(false);

    const onEditClick = () => {
        dispatch(FJActionModal.addAsEditPageAction([creationList[0].id]));
    };
    const onDownloadClick = () => {
        setIsDownload(true);
        FJRequirementsUtil.multiDownloadByUrls(
            [creationList[0].videoUrl],
            () => {
                setIsDownload(false);
            },
            { isVideo: true },
        );
    };
    const shareToSociety = type => {
        dispatch(FJActionModal.shareToSocietyAction(creationList[0].id, type));
    };

    return (
        <FJAIVideoGeneratorBtnGroup
            onDownloadClick={onDownloadClick}
            onEditClick={onEditClick}
            shareToSociety={shareToSociety}
            width={width}
            addAsEditPageModalBtuStatus={addAsEditPageModalBtuStatus}
            isDownload={isDownload}
        />
    );
};

FJAIVideoGeneratorBtnGroupContainer.propTypes = {
    width: PropTypes.number,
};

export default FJAIVideoGeneratorBtnGroupContainer;
